/**
 *
 * Pricing
 *
 */

import React, { memo, useCallback, useEffect } from 'react';
import { NotfoundWrapper } from './styled';
import { NextSeo } from 'next-seo';
import { useGetTenant } from '@containers/Home/hook/useGetTenant';

const NotFound = memo(() => {
  const { tenant, onGetTenantByDomain } = useGetTenant({ host: '' });

  const onGoBackDashboard = useCallback(
    () => window.open(tenant?.domain_studio, '_self'),
    [tenant?.domain_studio],
  );

  useEffect(() => {
    onGetTenantByDomain();
  }, [onGetTenantByDomain]);

  return (
    <>
      {tenant && (
        <NextSeo
          title={tenant?.title}
          description={tenant?.description}
          additionalMetaTags={[
            {
              property: 'name',
              content: tenant?.name,
            },
            {
              name: 'application-name',
              content: tenant?.name,
            },
          ]}
          additionalLinkTags={[
            {
              rel: 'shortcut icon',
              href: tenant?.favicon?.src,
            },
          ]}
          openGraph={{
            type: 'website',
            url: tenant?.domain_public + '/404',
            title: tenant?.title,
            description: tenant?.description,
            images: [
              {
                url: tenant?.logo?.src,
                width: 800,
                height: 600,
                alt: tenant?.name,
              },
            ],
            site_name: tenant?.name,
          }}
        />
      )}
      <NotfoundWrapper>
        <div className="topLogo" onClick={onGoBackDashboard}>
          <img src={tenant?.logo?.src} alt="" />
        </div>

        <div className="mainBlock">
          <div className="bgBox">
            <img
              src={`${tenant?.domain_studio}/images/taxi-family.png`}
              alt=""
            />
          </div>
          <h3>Oop!</h3>
          <p>Page not found</p>
          <p />
          <button type="button" onClick={onGoBackDashboard}>
            Back to home page
          </button>
        </div>
      </NotfoundWrapper>
    </>
  );
});

export default NotFound;
